import { Grid2, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "../../../hooks/useTranslate";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { useStudents } from "../../../context/students";
import TaskCard from "../../../components/TaskCard";
import Students1 from "../../../assets/images/images/students6.jpg";
import Students2 from "../../../assets/images/images/students5.jpg";
import { ISAMS_LINK } from "../../../services/isamsConfig";

const ExamsInformation = () => {
    const { t } = useTranslate();
    const navigate = useNavigate();
    const { activeStudentId } = useStudents();

    return (
        <div className="page-content">
            <div className="student-head-section" />
            <Grid2 container spacing={2} className="min-head-section-height">
                <Grid2 size={{ xs: 12, md: 7, lg: 8 }}>
                    <Breadcrumbs
                        breadcrumbs={[
                            { label: t("navigation.home"), href: `/home/${activeStudentId}` },
                            { label: t("examsInformation.title"), current: true },
                        ]}
                    />
                    <Typography variant="h1" className="text-white">
                        {t("examsInformation.title")}
                    </Typography>
                    <Typography variant="body1" className="mt-4 text-white" component="div">
                        {t("examsInformation.subtitle")}
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 5, lg: 4 }}>
                    <div className="images-head-section">
                        <div className="img-head-section">
                            <img alt="students-1" src={Students1} />
                        </div>
                        <div className="img-head-section">
                            <img alt="students-2" src={Students2} />
                        </div>
                    </div>
                </Grid2>
            </Grid2>
            <div className="relative z-1">
                <Typography variant="h1" component="h2">
                    {t("common.quickLinks")}
                </Typography>
                <Grid2 container spacing={4} className="mt-4">
                    <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                        <TaskCard title={t("examsInformation.examInformation")}>
                            <Typography variant="body1" components="div">
                                {t("examsInformation.examInformationText")}
                            </Typography>
                            <Button
                                href="https://read.bookcreator.com/aoDdErE8hKpL6whSI4MpgYro6P00PRSjMASfBSFzEoM/2eTwQCl3RhqI_DBm9iClLA"
                                target="_blank"
                                className="w-full mt-4 text-base button-primary"
                            >
                                {t("button.viewNow")}
                            </Button>
                        </TaskCard>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                        <TaskCard title={t("examsInformation.accessArrangements")}>
                            <Typography variant="body1" components="div">
                                {t("examsInformation.accessArrangementsText")}
                            </Typography>
                            <Button
                                href="https://publuu.com/flip-book/813613/2426573"
                                target="_blank"
                                className="w-full mt-4 text-base button-primary"
                            >
                                {t("button.viewNow")}
                            </Button>
                        </TaskCard>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                        <TaskCard title={t("examsInformation.takingExaminations")}>
                            <Typography variant="body1" components="div">
                                {t("examsInformation.takingExaminationsText")}
                            </Typography>
                            <Button
                                href="https://read.bookcreator.com/aoDdErE8hKpL6whSI4MpgYro6P00PRSjMASfBSFzEoM/6xMLOhWARRmDlDqWNSMTkg"
                                target="_blank"
                                className="w-full mt-4 text-base button-primary"
                            >
                                {t("button.viewNow")}
                            </Button>
                        </TaskCard>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                        <TaskCard title={t("examsInformation.examResults")}>
                            <Typography variant="body1" components="div">
                                {t("examsInformation.examResultsText")}
                            </Typography>
                            <Button
                                href="https://read.bookcreator.com/aoDdErE8hKpL6whSI4MpgYro6P00PRSjMASfBSFzEoM/HGw_lsuNTp2SoXFovMLZxA"
                                target="_blank"
                                className="w-full mt-4 text-base button-primary"
                            >
                                {t("button.viewNow")}
                            </Button>
                        </TaskCard>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                        <TaskCard title={t("examsInformation.remoteInvigilationService")}>
                            <Typography variant="body1" components="div">
                                {t("examsInformation.remoteInvigilationServiceText")}
                            </Typography>
                            <Button
                                href="https://kingsinterhigh.co.uk/our-school/online-exams/"
                                target="_blank"
                                className="w-full mt-4 text-base button-primary"
                            >
                                {t("button.viewNow")}
                            </Button>
                        </TaskCard>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                        <TaskCard title={t("examsInformation.examEntries")}>
                            <Typography variant="body1" components="div">
                                {t("examsInformation.examEntriesText")}
                            </Typography>
                            <Button
                                href={`https://${ISAMS_LINK}/#/school-profile/public-exams`}
                                target="_blank"
                                className="w-full mt-4 text-base button-primary"
                            >
                                {t("button.viewNow")}
                            </Button>
                        </TaskCard>
                    </Grid2>
                    <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                        <TaskCard title={t("examsInformation.bookExamSupport")}>
                            <Typography variant="body1" component="div">
                                {t("examsInformation.bookExamSupportText")}
                            </Typography>
                            <Button
                                onClick={() => navigate(`/exams-information/exam-support/${activeStudentId}`)}
                                className="w-full mt-4 text-base button-primary"
                            >
                                {t("button.viewNow")}
                            </Button>
                        </TaskCard>
                    </Grid2>
                </Grid2>
            </div>
        </div>
    );
};

export default ExamsInformation;
